/*
 * Copyright (c) 2018 Barclays PLC.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Barclays PLC.
 * ("Confidential Information").
 *
 * File: loanAmountFieldSet.js
 * Created: Oct 25, 2018
 */

import React from 'react';
import { Field } from 'redux-form';
import { required, rangeAmount } from '../../../utils/validate';
import { formatAmount, toNumber } from '../../../utils/formatters';
import Input from '../../Forms/Input/input';
import PropTypes from 'prop-types';
import moneyFormatter from "money-formatter";
import { memoize } from 'ramda';

const memoizeRangeAmount = memoize((min, max) => rangeAmount.bind(null, Number(min), Number(max)));

const LoanAmountFieldSet = (props) => {
  const { minAmount, maxAmount } = props;
  const loanAmountLabel = `Loan amount (${moneyFormatter.format('USD', minAmount, 0)} - ${moneyFormatter.format('USD', maxAmount, 0)})`;

  return (
    <fieldset className="container">
      <legend className="row"/>
      <div className="row">
        <div className="col-12 col-lg-6">
          <Field
            name="loanAmount"
            label={loanAmountLabel}
            component={Input}
            type="text"
            format={formatAmount}
            normalize={toNumber}
            validate={[required, memoizeRangeAmount(minAmount, maxAmount)]}
            required={true}
          />
        </div>
      </div>
    </fieldset>);
};

export default LoanAmountFieldSet;

LoanAmountFieldSet.propTypes = {
  minAmount: PropTypes.string.isRequired,
  maxAmount: PropTypes.string.isRequired
};
